<template>
  <div class="cec-container">
    <h1>CEC项目</h1>
    <div class="subtitle">EE快速通道</div>
    
    <div class="content">
      <h2>基本要求：</h2>
      <ul>
        <li>
          <strong>加拿大工作经验：</strong>过去3年中至少有1年全职或相同时间的兼职的NOC TEER 0,1,2,3工作经验（工作经验可以不连续，但连续的工作时间、自雇时间以及境外工作时间不算在内）
        </li>
        <li>
          <strong>语言要求：</strong>
          <ul>
            <li>NOC TEER 0 or 1岗位CLB 7</li>
            <li>NOC TEER 2 or 3岗位CLB 5</li>
          </ul>
        </li>
        <li>
          <strong>资金要求：</strong>无安置资金要求
        </li>
        <li>
          <strong>居住地：</strong>居住在Quebec以外的其它省份或地区
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CECView'
}
</script>

<style scoped>
.cec-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

h1 {
  font-size: 36px;
  color: #333;
  margin-bottom: 10px;
}

.subtitle {
  font-size: 18px;
  color: #666;
  margin-bottom: 30px;
}

h2 {
  font-size: 24px;
  color: #333;
  margin: 30px 0 20px;
}

.content {
  font-size: 16px;
  line-height: 1.8;
  color: #444;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 20px;
  padding-left: 20px;
  position: relative;
}

li:before {
  content: '•';
  position: absolute;
  left: 0;
  color: #666;
}

li ul {
  margin-top: 10px;
  margin-left: 20px;
}

li ul li {
  margin-bottom: 10px;
}

strong {
  color: #333;
}
</style>